import { useState } from "react";
import { Arrow, Icon, type IconName } from "../components/Icons";
import SectionLabel from "../components/SectionLabel";
import { expertise, portfolio, process } from "../data/portfolio";

export default function Expertise() {
  const [stage, setStage] = useState(0);
  return (
    <section id="expertise" className="expertise light-section section">
      <div className="container">
        <SectionLabel index="02">What I bring</SectionLabel>
        <div className="expertise-intro">
          <h2>
            From the first sketch
            <br />
            <span>to a working website.</span>
          </h2>
          <p>
            I work on both the design and the code. Here’s what that looks like
            across the projects I’m building.
          </p>
        </div>
        <div className="expertise-list">
          {expertise.map((item, i) => (
            <article key={item.title}>
              <span className="mono expertise-number">0{i + 1}</span>
              <h3>{item.title}</h3>
              <div>
                <p>{item.text}</p>
                <span className="mono">{item.tags}</span>
              </div>
              <span className="expertise-symbol" aria-hidden="true">
                <Icon name={(["diagonal", "cube", "code", "spark"] as IconName[])[i]} />
              </span>
            </article>
          ))}
        </div>
        <div className="toolbox">
          <span className="mono">The current toolkit</span>
          <p>
            {portfolio.technologies.map((tech) => (
              <span key={tech}>{tech}</span>
            ))}
          </p>
        </div>
        <div className="process">
          <div className="process-heading">
            <SectionLabel index="The process">Keep refining</SectionLabel>
            <p>
              How I take a project
              <br />
              from idea to launch.
            </p>
          </div>
          <div
            className="process-track"
            role="group"
            aria-label="Explore the development process"
          >
            {process.map((item, i) => (
              <button
                key={item.title}
                aria-pressed={stage === i}
                onClick={() => setStage(i)}
              >
                <span className="mono">
                  0{i + 1}
                  <Arrow diagonal />
                </span>
                <strong>{item.title}</strong>
                <span className="process-dot" />
              </button>
            ))}
          </div>
          <div className="process-detail" aria-live="polite">
            <span className="mono">
              0{stage + 1} / {process[stage].title}
            </span>
            <p>{process[stage].text}</p>
            <svg viewBox="0 0 200 44" aria-hidden="true">
              <path
                d={
                  [
                    "M4 22h192",
                    "M4 22Q50-12 100 22t96 0",
                    "M4 22Q28-10 52 22T100 22T148 22T196 22",
                    "M4 22Q16 4 28 22T52 22T76 22T100 22T124 22T148 22T172 22T196 22",
                  ][stage]
                }
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
